export default __webpack_public_path__ + "static/media/promo-mood.3ab9c397.png";